// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout_header__uDq0x","main":"Layout_main__mnOGO","footer-minimal":"Layout_footer-minimal__NiHGP"};